var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2027 40.0745C8.168 42.391 -2.41079 47.1213 4.03241 53.0407C7.17986 55.932 10.6853 58 15.0925 58H40.2408C44.6481 58 48.1536 55.932 51.3009 53.0407C57.7441 47.1213 47.1654 42.391 43.1306 40.0745C33.6693 34.6418 21.6641 34.6418 12.2027 40.0745Z",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15C41 22.1797 35.1798 28 28 28C20.8203 28 15 22.1797 15 15C15 7.8203 20.8203 2 28 2C35.1798 2 41 7.8203 41 15Z",
    stroke: "#111111",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientFamily);
export default __webpack_public_path__ + "static/media/patientFamily.97396722a7e71e71294b73a4998f442b.svg";
export { ForwardRef as ReactComponent };